module.exports = __webpack_public_path__ + "assets/img/download-bottom.043e22ea.png";